import cn from 'classnames';
import { tabItems } from '../../constants/model';
import { ModelDetailType } from '../../types';
import s from './TabBar.module.scss';

export const TabBar = ({
  data,
  slug,
  cityName
}: {
  data: ModelDetailType;
  slug: string[] | string;
  cityName: string
}) => {
  function isSelected(item) {
    const lastSlug = slug?.[2];
    if (lastSlug) {
      if (item.link === lastSlug) { 
        return true;
      }
      else if (lastSlug.includes("price-in") && item?.name === "Price") {
        return true;
      }
    } else if (item.name === 'Overview') {
      return true;
    }
    return false;
  }
  return (
    <div className={s.root}>
      {tabItems?.map((item) => (
        <a
          className={cn(s.box, { [s.selected]: isSelected(item) })}
          key={item.value}
          href={`/new-cars/${data.modelSeoData.brandSlug}-car/${data.modelSeoData.modelSlug
          }${item.link ? item.link==="price" ? `/price-in-${cityName?.toLocaleLowerCase().replace(" ", "-")}`: `/${item.link}` : ''}`}
          id={item.link}
        >
          {item.name}
        </a>
      ))}
    </div>
  );
};
